import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { PublicHeader, PublicFooter } from '../components/PublicLayout';
import { authorsAPI } from '../lib/api';
import { Skeleton } from '../components/ui/skeleton';
import { Badge } from '../components/ui/badge';
import { FileText, Eye, Users } from 'lucide-react';

export default function AuthorsPage() {
  const [authors, setAuthors] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { loadAuthors(); }, []);

  const loadAuthors = async () => {
    try {
      const res = await authorsAPI.list({ limit: 50 });
      setAuthors(res.data.authors || []);
    } catch {}
    finally { setLoading(false); }
  };

  return (
    <>
      <PublicHeader />
      <main className="bg-[#FBF7EF] min-h-screen">
        <section className="max-w-[1200px] mx-auto px-4 sm:px-6 py-10" data-testid="authors-page">
          <div className="flex items-center gap-3 mb-8">
            <Users className="w-6 h-6 text-[#B89B5E]" />
            <h1 className="news-masthead text-3xl font-bold">Our Journalists</h1>
          </div>

          {loading ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {[1,2,3,4,5,6].map(i => <Skeleton key={i} className="h-48 rounded-xl" />)}
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {authors.map(author => (
                <Link key={author.id} to={`/author/${author.id}`} className="news-card group block bg-white rounded-xl overflow-hidden border border-[#E7E0D6] p-6" data-testid="author-card">
                  <div className="flex items-start gap-4">
                    {author.avatar_url ? (
                      <img src={author.avatar_url} alt="" className="w-14 h-14 rounded-full object-cover flex-shrink-0" />
                    ) : (
                      <div className="w-14 h-14 rounded-full bg-[#B89B5E]/10 flex items-center justify-center text-xl font-bold text-[#B89B5E] news-masthead flex-shrink-0">
                        {author.full_name?.charAt(0) || '?'}
                      </div>
                    )}
                    <div className="flex-1 min-w-0">
                      <h3 className="font-semibold group-hover:underline">{author.full_name}</h3>
                      <p className="text-xs text-[#5B616E] capitalize">{author.role?.replace('_', ' ')}</p>
                      {author.bio && <p className="text-xs text-[#5B616E] mt-2 line-clamp-2">{author.bio}</p>}
                    </div>
                  </div>
                  <div className="flex items-center gap-4 mt-4 pt-4 border-t border-[#E7E0D6] text-xs text-[#5B616E]">
                    <div className="flex items-center gap-1"><FileText className="w-3 h-3" /> {author.article_count || 0} articles</div>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </section>
      </main>
      <PublicFooter />
    </>
  );
}
